import * as React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import { MainFrame } from "src/components/MainFrame";
import { NoMatch } from "src/pages/NoMatch";

import { makeUrl } from "./makeUrl";
import { PageUrl } from "./PageUrl";
import { routes } from "./routes";

const navigateDef = <Navigate to={makeUrl(PageUrl.home)} />;

// Нужно отрезать первый слэш
const langPath = (path: string) => (path[0] === "/" ? path.slice(1) : path);

export const createMainRouter = () =>
  createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<MainFrame />}>
        {/* Редирект на дефолтную страницу */}
        <Route
          index
          element={<Navigate replace to={makeUrl(PageUrl.home)} />}
        />
        <Route path="/:lang" element={navigateDef} />
        <Route path="/:lang">
          {routes.map(([path, Component]) => (
            <Route key={path} path={langPath(path)} element={<Component />} />
          ))}
        </Route>
        <Route path="*" element={<NoMatch />} />
      </Route>,
    ),
  );
